import { gql } from '@apollo/client'

export interface AiSuggestion {
  id: string
  title: string
  prompt: string
}

export interface GetAiSuggestionsResponse {
  aiSuggestions: AiSuggestion[]
}

// Temporarily commented out - aiSuggestions field doesn't exist in schema
// export const GET_AI_SUGGESTIONS = gql`
//   query GetAiSuggestions($search: String!) {
//     aiSuggestions(search: $search) {
//       id
//       title
//       prompt
//     }
//   }
// `

export const AIRCRAFTS_QUERY = gql`
  query Aircrafts($orgSlug: String!) {
    aircrafts(orgSlug: $orgSlug) {
      id
      tailNumber
    }
  }
`
